export function selectedBlogAssignment(user, selectedBlog) {
  if (!selectedBlog?.id) return null;
  return user?.blogs?.find((blog) => Number(blog.id) === Number(selectedBlog.id)) || null;
}

export function selectedBlogBuilderAccess(user, selectedBlog) {
  if (user?.role === 'super_admin') return 'full';
  const assignment = selectedBlogAssignment(user, selectedBlog);
  if (!assignment) return 'none';
  if (user?.auth_source === 'local') return 'full';
  return ['full', 'customer'].includes(assignment.document_builder_access)
    ? assignment.document_builder_access : 'none';
}

export function isCustomerDocumentPath(path) {
  return /^\/(customer-documents|customer-document-editor)\/?(?:[?#]|$)/.test(path);
}

export function builderRedirect(redirect, customerDocsOnly) {
  const fallback = customerDocsOnly ? '/customer-documents' : '/dashboard';
  if (typeof redirect !== 'string' || !redirect.startsWith('/') || redirect.startsWith('//') || redirect.includes('\\')) return fallback;
  if (customerDocsOnly && !isCustomerDocumentPath(redirect)) return fallback;
  return redirect;
}

export function isSelectedBlogViewer(user, selectedBlog) {
  if (user?.role === 'super_admin') return false;
  return selectedBlogAssignment(user, selectedBlog)?.blog_role === 'viewer';
}

export function canEditSelectedBlog(user, selectedBlog) {
  return Boolean(selectedBlog?.id && user && (user.role === 'super_admin' || !isSelectedBlogViewer(user, selectedBlog)));
}

export function routedDocumentPermissions(metadata) {
  const permissions = metadata?.permissions || {};
  const fallbackCanEdit = metadata?.blogRole ? metadata.blogRole !== 'viewer' : false;

  return {
    canEdit: typeof permissions.canEdit === 'boolean' ? permissions.canEdit : fallbackCanEdit,
    canPublish: permissions.canPublish === true,
    canDownload: permissions.canDownload === true
  };
}

export function canEditRoutedDocument(metadata) {
  return routedDocumentPermissions(metadata).canEdit;
}
